function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  stroke: "#892034",
  strokeWidth: 1.5,
  fill: "#FFFFFF",
  x: 5,
  y: 5,
  width: 160,
  height: 100,
  rx: 5
}), /*#__PURE__*/React.createElement("g", {
  id: "IBAN",
  transform: "translate(19.85, 37.3)",
  fill: "#892034",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "7.5 0 0 35.7 7.85 35.7 15.4 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.1809519,14.45 L30.9309519,6.1 L39.2309519,6.1 C40.4976185,6.1 41.5059519,6.35833333 42.2559519,6.875 C43.0059519,7.39166667 43.3809519,8.35 43.3809519,9.75 C43.3809519,11.3166667 42.8559519,12.4916667 41.8059519,13.275 C40.7559519,14.0583333 39.5142852,14.45 38.0809519,14.45 L29.1809519,14.45 Z M24.6309519,0 L17.1809519,35.7 L36.1809519,35.7 C37.9809519,35.7 39.6976185,35.45 41.3309519,34.95 C42.9642852,34.45 44.4142852,33.7166667 45.6809519,32.75 C46.9476185,31.7833333 47.9559519,30.5666667 48.7059519,29.1 C49.4559519,27.6333333 49.8309519,25.9333333 49.8309519,24 C49.8309519,22.2666667 49.3726185,20.7416667 48.4559519,19.425 C47.5392852,18.1083333 46.2309519,17.2166667 44.5309519,16.75 L44.5309519,16.65 C45.5976185,16.5166667 46.5392852,16.2 47.3559519,15.7 C48.1726185,15.2 48.8726185,14.575 49.4559519,13.825 C50.0392852,13.075 50.4809519,12.225 50.7809519,11.275 C51.0809519,10.325 51.2309519,9.35 51.2309519,8.35 C51.2309519,6.65 50.9642852,5.25833333 50.4309519,4.175 C49.8976185,3.09166667 49.1309519,2.24166667 48.1309519,1.625 C47.1309519,1.00833333 45.9142852,0.583333333 44.4809519,0.35 C43.0476185,0.116666667 41.4309519,0 39.6309519,0 L24.6309519,0 Z M25.9809519,29.6 L28.0809519,19.8 L35.7809519,19.8 C36.4809519,19.8 37.1976185,19.8333333 37.9309519,19.9 C38.6642852,19.9666667 39.3309519,20.1416667 39.9309519,20.425 C40.5309519,20.7083333 41.0226185,21.1166667 41.4059519,21.65 C41.7892852,22.1833333 41.9809519,22.9166667 41.9809519,23.85 C41.9809519,25.75 41.4059519,27.1833333 40.2559519,28.15 C39.1059519,29.1166667 37.6309519,29.6 35.8309519,29.6 L25.9809519,29.6 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.0619037,0 L52.0119037,35.7 L60.2619037,35.7 L64.7619037,27.75 L78.1119037,27.75 L79.2619037,35.7 L87.0619037,35.7 L81.1119037,0 L73.0619037,0 Z M67.8619037,21.9 L75.5619037,7.7 L75.6619037,7.7 L77.4119037,21.9 L67.8619037,21.9 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "99.7928556 0 92.2928556 35.7 99.5928556 35.7 104.692856 10.65 104.792856 10.65 114.592856 35.7 122.442856 35.7 129.992856 0 122.792856 0 117.692856 25.4 117.592856 25.4 107.892856 0"
})));

var SvgA2A = function SvgA2A(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 170 110",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgA2A, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/A2A.715e464b.svg";
export { ForwardRef as ReactComponent };